module.exports = __webpack_public_path__ + "img/3-5.f8b2c417.svg";